import { Connection } from "@solana/web3.js";

export const createConnection = () => {
    try {
        return new Connection(process.env.VUE_APP_SOLSCAN_RPC, "confirmed");
    } catch (error) {
        return null;
    }
};
